import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from '../../../../../context';
import BtxSwitch from '../../../../Forms/BtxSwitch';

const ViewTestPracticesToggle = ({ styles = {} }) => {
    // bool tied to the view test practices toggle
    const includeTestPractices = useSelector(state => state.practice.includeTestPractices);
    const dispatch = useDispatch();
    const onChange = useCallback(() => {
        dispatch(
            actions.practice.setIncludeTestPractices(
                !includeTestPractices
            )
        )
    }, [includeTestPractices, dispatch]);
    return (
        <BtxSwitch {...styles} onChange={onChange}
            value={includeTestPractices}
            label='View Test Practices'
        />
    );
};

export default ViewTestPracticesToggle;
